import React from 'react';
import './PopupDailyPlanSets.css';

const PopupDailyPlanSets = ({ date, setsData, onClose }) => {
  return (
    <div className="daily-plan-sets-popup-overlay">
      <div className="daily-plan-sets-popup">
        <div className="daily-plan-sets-popup-header">
          <h2>Planned Sets for {date.toLocaleDateString()}</h2>
          <button className="daily-plan-sets-popup-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="daily-plan-sets-popup-content">
          {setsData.length === 0 ? (
            <p>No planned sets for this date.</p>
          ) : (
            <table className="daily-plan-sets-popup-table">
              <thead>
                <tr>
                  <th>Brand</th>
                  <th>Set Name</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {setsData.map((set, index) => (
                  <tr key={index}>
                    <td>{set.brandID}</td>
                    <td>{set.setmane}</td>
                    <td>{set.qty_to_produce.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupDailyPlanSets;